export default __webpack_public_path__ + "static/media/first.707e0286.svg";